import { createSlice } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchBestPortfolioEventsGroupThunk } from 'shared/lib';
import { PortfolioEventCardModel, PortfolioEventCardModelSchema } from 'entities/portfolio-event';
import BaseError from '../../../utils/base-error';

export type PortfolioBlockState = {
    loaded: boolean
    errors: BaseError[]
    image?: ImageModel
    portfolioEventCards: PortfolioEventCardModel[]
}

const initialState: PortfolioBlockState = {
    loaded: false,
    errors: [],
    portfolioEventCards: [],
};

// eslint-disable-next-line import/prefer-default-export
export const portfolioBlockSlice = createSlice({
    name: 'portfolioBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchBestPortfolioEventsGroupThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        state.portfolioEventCards = response.data.data.events?.map(({
                            slug,
                            name,
                            images,
                            description,
                        }) => PortfolioEventCardModelSchema.parse({
                            uid: slug,
                            name,
                            description,
                            images: images?.map(({ url }) => ImageModelSchema.parse({
                                url: createStrapiMediaUrl(url),
                            })),
                        })) || [];

                        if (response.data.data.image) {
                            state.image = {
                                url: createStrapiMediaUrl(response.data.data.image.url),
                            };
                        }
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});

export const usePortfolioBlockState = () => useAppSelector((store) => store.portfolioBlock);
